import { useFormik } from "formik";
import { adminCreateAdmin } from "helpers/backend_helpers";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { toast } from "react-toastify";
import {
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import * as Yup from "yup";

const AddModalAdmin = ({ show, onCloseClick, getData }: any) => {
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      noId: "",
      type: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Nama harus diisi!"),
      noId: Yup.string().required("No ID harus diisi!"),
      type: Yup.string().required("Tipe harus diisi!"),
    }),
    onSubmit: (values) => {
      adminCreateAdmin(values)
        .then((response: any) => {
          onCloseClick();
          getData();
          toast.success(
            <div>
              Admin <b>{response?.name}</b> berhasil ditambahkan!
            </div>
          );
          validation.resetForm();
        })
        .catch(() => {});
    },
  });

  const comboType = [
    { value: "ADMIN", label: "Admin" },
    { value: "GUEST", label: "Guest" },
  ];

  useEffect(() => {
    if (!show) {
      validation.resetForm();
    }
  }, [show]);

  return (
    <Modal fade={true} isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalHeader className="bg-light p-3" toggle={onCloseClick}>
        Tambah Admin
      </ModalHeader>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <ModalBody>
          <div className="mb-3">
            <Label htmlFor="name" className="form-label">
              Nama
            </Label>
            <Input
              type="text"
              className="form-control"
              id="name"
              name="name"
              placeholder="Enter name"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.name || ""}
              invalid={
                validation.touched.name && validation.errors.name ? true : false
              }
            />
            {validation.errors.name && validation.touched.name ? (
              <FormFeedback type="invalid">
                {validation.errors.name}
              </FormFeedback>
            ) : null}
          </div>
          <div className="mb-3">
            <Label htmlFor="type" className="form-label">
              Tipe
            </Label>
            <Input
              name="type"
              type="select"
              className="form-select"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.type || ""}
              invalid={
                validation.touched.type && validation.errors.type ? true : false
              }
            >
              <option value="">Pilih Tipe</option>
              {comboType.map((item, index) => (
                <option value={item.value} key={index}>
                  {item.label}
                </option>
              ))}
            </Input>
            {validation.errors.type && validation.touched.type ? (
              <FormFeedback type="invalid">
                {validation.errors.type}
              </FormFeedback>
            ) : null}
          </div>
          <div className="mb-3">
            <Label htmlFor="noId" className="form-label">
              No ID
            </Label>
            <Input
              type="text"
              className="form-control"
              id="noId"
              name="noId"
              placeholder="Enter no id"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.noId || ""}
              invalid={
                validation.touched.noId && validation.errors.noId ? true : false
              }
            />
            {validation.errors.noId && validation.touched.noId ? (
              <FormFeedback type="invalid">
                {validation.errors.noId}
              </FormFeedback>
            ) : null}
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-soft-danger waves-effect waves-light material-shadow-none btn-sm"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            Batal
          </button>
          <button
            type="submit"
            className="btn btn-soft-success waves-effect waves-light material-shadow-none btn-sm"
          >
            Tambah
          </button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

AddModalAdmin.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  getData: PropTypes.func,
};

export default AddModalAdmin;
